import { Component } from '@angular/core';

@Component({
  selector: 'app-btn-loader',
  templateUrl: './btn-loader.component.html',
  styleUrl: './btn-loader.component.scss'
})
export class BtnLoaderComponent {

}
